import { render, staticRenderFns } from "./payment-options.vue?vue&type=template&id=31eb7fa8"
import script from "./payment-options.vue?vue&type=script&lang=ts"
export * from "./payment-options.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/vercel/path0/components/loading-spinner.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default})
